import * as React from 'react';
import styled from 'styled-components';
import { tabletMedia } from '../../util/style/tablet-media';
import { addOpacity } from '../../util/style/add-opacity.util';
import { SizeHelper } from '../../util/style/size-helper';
import { inject, observer } from 'mobx-react';
import { IInjectedProps } from '../../interface/component/injected-props.interface';
import { getLinkFinalURL } from '../../util/url/get-link-final-url';
import { isStringEmpty } from '../../util/string/is-string-empty.util';
import { COOKIE_POLICY_Z_INDEX } from '../../constants';
import { CmsButton } from '../cms-button/cms-button';

const CookiePolicyContainer = styled.div<{ backgroundColor: string }>`
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  flex-direction: row;
  z-index: ${COOKIE_POLICY_Z_INDEX};
  padding: 30px;
  width: ${SizeHelper.fullWidth};
  background: ${(props) => props.backgroundColor};
  ${tabletMedia(`
    flex-direction: column;
    padding: 15px;
  `)};
`;

interface ILinkContainerProps {
  text: string;
  linkTo?: string;
}

const TextLinkContainer = styled.a`
  font-size: 20px;
`;
const TextContainer = styled.span`
  font-size: 20px;
`;
const LinkContainer = (props: ILinkContainerProps) => {
  if (!isStringEmpty(props.linkTo)) {
    return <TextLinkContainer
      href={props.linkTo}
      target="_blank"
    >
      {props.text}
    </TextLinkContainer>;
  }
  return (
    <TextContainer>
      {props.text}
    </TextContainer>
  );
};
const ButtonContainer = styled.div`
  max-width: 250px;
  cursor: pointer;
`;

const TextAndLinkContainer = styled.div<{ color: string } & React.HTMLAttributes<HTMLDivElement>>`
  margin-right: 30px;
  ${tabletMedia(`
    margin-right: 0px;
    margin-bottom: 15px;
  `)};
  flex: 1;
  & a {
      color: ${(props) => props.color} !important;
      text-decoration: underline !important;
      cursor: pointer;
  }
  & span {
    color: ${(props) => props.color} !important;
  }
`;

@inject('state', 'dispatch')
@observer
export class CookiePolicy extends React.Component<IInjectedProps> {
  render() {
    if (this.props.state.configuration.inAdmin) {
      return null;
    }
    if (this.props.state.configuration.cookiePolicyAccepted) {
      return null;
    }
    const backgroundColor = addOpacity(this.props.state.colors.getColor(
      this.props.state.configuration.settings.cookiePolicy.cookieWarningBackgroundColor), this.props.state.configuration.settings.cookiePolicy.cookieWarningOpacity);
    const fontColor = this.props.state.colors.getColor(
      this.props.state.configuration.settings.cookiePolicy.cookieWarningFontColor);

    return (
      <CookiePolicyContainer backgroundColor={backgroundColor}>
        <TextAndLinkContainer color={fontColor}>
          <LinkContainer
            linkTo={getLinkFinalURL(
              this.props.state,
              this.props.state.configuration.settings.cookiePolicy.cookieWarningLink
            )}
            text={this.props.state.configuration.settings.cookiePolicy.cookieWarningText}
          />
        </TextAndLinkContainer>
        <ButtonContainer>
          <CmsButton
            onClick={this.props.dispatch.cookiePolicyAccepted}
            color={this.props.state.configuration.settings.cookiePolicy.cookieWarningButtonColor}
            text={this.props.state.configuration.settings.cookiePolicy.cookieWarningButtonText}
          />
        </ButtonContainer>
      </CookiePolicyContainer>
    );
  }
}
